import l, { forwardRef as K } from "react";
import { Flex as u } from "../Flex/Flex.js";
import { Close as Q } from "./components/Close/index.js";
import { ConditionalFloatingPortal as X } from "./components/ConditionalFloatingPortal/index.js";
import { Text as x } from "../Text/Text.js";
import { FloatingArrow as Y } from "@floating-ui/react";
import { cls as n } from "../../helpers/cls.js";
import { useTooltip as Z } from "./hooks/useTooltip.js";
import { arrowDimensions as r } from "./constants/arrowDimensions.js";
import { useCallbacks as ee } from "./hooks/useCallbacks.js";
var te = Object.defineProperty,
  oe = Object.defineProperties,
  le = Object.getOwnPropertyDescriptors,
  h = Object.getOwnPropertySymbols,
  ie = Object.prototype.hasOwnProperty,
  ae = Object.prototype.propertyIsEnumerable,
  w = (o, e, t) => e in o ? te(o, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: t
  }) : o[e] = t,
  s = (o, e) => {
    for (var t in e || (e = {})) ie.call(e, t) && w(o, t, e[t]);
    if (h) for (var t of h(e)) ae.call(e, t) && w(o, t, e[t]);
    return o;
  },
  c = (o, e) => oe(o, le(e));
typeof window != "undefined" && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = "3.35.0");
const O = K((_ref, T) => {
  let {
    className: o,
    children: e,
    description: t,
    disableHover: g,
    disablePressOutsideClose: E,
    disableFlip: C,
    disablePositionShift: p,
    disableEscClose: v,
    disableTouchInteraction: S,
    enablePortal: y,
    height: P,
    hideCloseButton: N,
    initialOpenState: R,
    maxWidth: k,
    maxHeight: I,
    open: D,
    openCallback: d,
    closeCallback: m,
    placement: i,
    title: f,
    variant: a = "default",
    width: j,
    zIndex: b,
    contentSlot: F
  } = _ref;
  const {
    arrowRef: H,
    context: B,
    floatingStyles: W,
    getReferenceProps: M,
    getFloatingProps: V,
    isMounted: _,
    mergedFloatingRef: $,
    refs: z,
    status: A,
    uncontrolledOpen: U,
    controlledOpen: L,
    isUncontrolledMode: q,
    handleClose: G
  } = Z({
    initialOpenState: R,
    disableEscClose: v,
    disableFlip: C,
    disableHover: g,
    disablePositionShift: p,
    disablePressOutsideClose: E,
    disableTouchInteraction: S,
    externalRef: T,
    height: P,
    maxHeight: I,
    maxWidth: k,
    open: D,
    placement: i,
    width: j,
    openCallback: d,
    closeCallback: m
  });
  ee({
    isUncontrolledMode: q,
    uncontrolledOpen: U,
    controlledOpen: L,
    openCallback: d,
    closeCallback: m,
    isMounted: _
  });
  const J = () => p && ((i == null ? void 0 : i.includes("start")) || (i == null ? void 0 : i.includes("end")));
  return l.createElement("span", {
    className: n("olx-tooltip", o)
  }, l.createElement("span", c(s({
    ref: z.setReference
  }, M()), {
    className: "olx-tooltip__reference"
  }), e), _ && l.createElement(X, {
    enabled: y
  }, l.createElement(u, c(s({
    className: n("olx-tooltip__floating", "olx-tooltip__floating--".concat(a)),
    "data-status": A,
    "data-ds-component": "DS-Tooltip",
    ref: $
  }, V()), {
    style: c(s({}, W), {
      "--tooltip-z-index": b != null ? b : "var(--z-index-950-popup)"
    }),
    tabIndex: 0
  }), l.createElement(u, {
    flexDirection: "column",
    className: "olx-tooltip__content-wrapper"
  }, f && l.createElement(x.BodySmall, {
    className: n("olx-tooltip__title", "olx-tooltip__title--".concat(a)),
    weight: "bold"
  }, f), l.createElement(x.BodySmall, {
    className: n("olx-tooltip__description", "olx-tooltip__description--".concat(a))
  }, t), F), !N && l.createElement(Q, {
    closeCallback: G,
    variant: a
  }), l.createElement(Y, {
    ref: H,
    context: B,
    width: r.width,
    height: r.height,
    tipRadius: r.tipRadius,
    className: n("olx-tooltip__arrow", "olx-tooltip__arrow--".concat(a)),
    staticOffset: J() ? "18px" : null
  }))));
});
O.displayName = "Tooltip";
export { O as Tooltip };